module.exports = __webpack_public_path__ + "static/media/3.7d6db5ab.jpg";